/** Components */
import {
    RequestIdWithWarning,
    replaceRequestId,
    RequestDays,
} from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';
import { ClientIdentification } from '../../components/utilities/Table/generalColumns/ClientIdentification';
import { OfficeRequest } from '../../components/utilities/Table/generalColumns/RegionalRequest';
import { ExecutiveWithTooltip } from '../../components/utilities/Table/generalColumns/ExecutiveWithTooltip';
import { StatusWithTooltip } from '../../components/utilities/Table/generalColumns/StatusWithTooltip';
import { DefineDate } from '../../components/utilities/Table/generalColumns/DefineDate';
import { CausalRequest } from '../../components/utilities/Table/generalColumns/CausalRequest';

const commonColumns = [
    RequestIdWithWarning('gestionsolicitud.fecha_creacion'),
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    ClientIdentification,
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
];

export const requestsListStatus = [
    {
        id: 'bolsa_general_mesa_de_ayuda',
        label: 'BOLSA GENERAL',
        status: 10,
        responsable: false,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, RequestDays('gestionsolicitud.fecha_creacion'));
            cols.splice(2, 0, {
                Header: 'Fecha Creación',
                accessor: 'gestionsolicitud.fecha_creacion',
            });
            cols.splice(5, 0, {
                Header: 'Origen',
                accessor: 'origen.label',
            });

            return cols;
        })(),

        buttonAction: [{ name: 'takeRequest' }],
        componentNoShowMenu: ['DocumentsCredit'],
    },
    {
        id: 'en_proceso_mesa_de_ayuda',
        label: 'EN PROCESO',
        status: 10,
        responsable: true,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, RequestDays('gestionsolicitud.fecha_creacion'));
            cols.splice(2, 0, {
                Header: 'Fecha Creación',
                accessor: 'gestionsolicitud.fecha_creacion',
            });
            cols.splice(5, 0, {
                Header: 'Origen',
                accessor: 'origen.label',
            });

            return cols;
        })(),
    },
    {
        id: 'procesadas_mesa_de_ayuda',
        label: 'PROCESADAS',
        status: false,
        nameColumnProcessed: [
            {
                name: 'estado_solicitud__gt',
                value: 10,
                operator: '%26',
            },
            {
                name: 'gestionsolicitud__usuario_mesa',
                value: 'user',
                operator: '|',
            },
            {
                name: 'gestionsolicitud__usuario_rechazo',
                value: 'user',
                operator: '|',
            },
            {
                name: 'gestionsolicitud__usuario_desistimiento',
                value: 'user',
                operator: '|',
            },
        ],
        responsable: false,

        columns: replaceRequestId(
            (() => {
                const cols = [...commonColumns];
                cols.splice(1, 0, DefineDate('mesa'));
                cols.splice(5, 0, OfficeRequest);
                cols.splice(6, 0, ExecutiveWithTooltip);
                cols.splice(7, 0, StatusWithTooltip);
                cols.splice(8, 0, CausalRequest);

                return cols;
            })()
        ),

        buttonAction: [{ name: 'resumeStatusRequest' }],
        componentNoShowMenu: ['DocumentsCredit'],
        registrationLimit: 5, // limit for registration in list credits
    },
];
